<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div>
      <b-card class="bCardGlobalXL" style="min-height: 38em;">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="10">
            <div>
              <p class="textoSubtitulo">Catálogo de tratamientos</p>
            </div>
          </b-col>
          <b-col cols="6" md="2">
            <div>
              <p style="text-align: end" class="textoSubtitulo">Cat_Tx</p>
            </div>
          </b-col>
        </b-row>

        <div class="d-flex">
          <div class="d-flex justify-content-center align-items-center" style="padding-left: 2%; padding-right: 2%; height: 2.5em"
               @click="opcionTabSeleccionada = index"
               :class="opcionTabSeleccionada == index ? 'tabOpciones seleccionado' : 'tabOpciones'"
               v-for="(opt, index) in opciones" :key="index" :title="opt.nombre">
            <p class="mt-3" :class="opcionTabSeleccionada == index ? 'tabTxtSeleccionado' : 'tabTxt'">
              {{ opt.nombre }}
            </p>
          </div>
        </div>

        <div class="w-100"  v-if="opcionTabSeleccionada === 0">
          <div class="tabs mt-4 d-flex justify-content-end">
            <nav class="tabs-nav">
              <ul>
                <li :class="{ active: tabSeleccionada === tab.idCategoriaNuevo }" v-for="(tab, index) in tabs" :key="index">
                  <a @click="seleccionarTab(tab.idCategoriaNuevo)" href="#">
                    {{ tab.descripcion }}
<!--                    <hr v-if="tabSeleccionada === tab.idCategoriaNuevo" style="background-color: #0069a9; height: 2px; width: 60%"/>-->
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
          <actualizacionPreciosMasivo v-if="opcionTabSeleccionada == 1" />

        <listaTratamientos :tabCategoria="tabSeleccionada" :opcionSeleccionada="opcionTabSeleccionada" v-if="opcionTabSeleccionada === 0 || opcionTabSeleccionada === 2"/>
      </b-card>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

import listaTratamientos from "../components/tratamientos_combos/listaTratamientos.vue";

import actualizacionPreciosMasivo from "../views/catalogos/actualizacionPrecioMasivo";

export default {
  name: "Tratamientos",
  props: {
    msg: String,
  },
  components: {
    Header,
    listaTratamientos,
    actualizacionPreciosMasivo,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    tabSeleccionada: 1,
    opcionTabSeleccionada: 0,
    tabs: null,

    opciones: [
        {nombre: "Lista tratamientos"},
        {nombre: "Actualización precios"},
        {nombre: "Histórico"}
      ]
  }),

  created() {
    this.obtenerCategorias();
    this.debug = this.$localStorageService.getDebug();
  },
  
  methods: {
    obtenerCategorias(){
      this.$http.post(this.$api + "categoriaNuevo/obtenerNuevasCategorias")
          .then((response) => {
            if (response.status === 200) {
              this.tabs = response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    seleccionarTab(index) {
      this.tabSeleccionada = index;
      this.opcionTabSeleccionada = 0;
    },
  },
};
</script>

<style scoped>
.tabTxtSeleccionado {
  font-size: 0.9vw;
  color: #17a2b8;
  width: 100%;
}

.tabTxt {
  font-size: 0.9vw;
  color: #717171;
}

.tabOpciones.seleccionado {
  border-style: solid;
  border-width: 1px;
  border-color: #90d3dd;
  border-radius: 10px;
  color: #17a2b8;
}

.tabOpciones:hover {
  font-weight: 600;
}

.tabs {
  position: relative;
  width: 100%;
}

.tabs .tabs-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.tabs .tabs-nav ul li {
  flex: 1 0 auto;
  margin: 0;
  border-bottom: 3px solid transparent;
}

.tabs .tabs-nav ul li a {
  display: block;
  padding: 0.4em 2em 0.4em 2em;
  border: none;
  color: #aaaaaa;
}

.tabs .tabs-nav ul li a:hover {
  /* al sobre poner el mouse */
  color: #369bda;
}

.border {
  /* borde inferior */
  border-bottom: 3px solid #0069a9;
  width: 20%;
}

.tabs .tabs-nav ul li.active a {
  color: #0069a9;
  font-weight: 600;
}

.tabs .tabs-content {
  width: 100%;
}
</style>
